module.exports = __webpack_public_path__ + "static/img/AI-6.519605f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AI-6.jpg
// module id = xfAi
// module chunks = 46